export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9624.e8f26a16.jpg";